const sampleHtmlSvg = `<span class="button_icon">
          <svg xml:space="preserve" style="enable-background:new 0 0 20 22;" viewBox="0 0 20 22" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="图层_1" version="1.1">
            <style type="text/css">
                .st0{fill:none;stroke:#3E3F46;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}
            </style>
            <path d="M1,15.6l9,5.4l9-5.4 M1,11l9,5.4l9-5.4 M1,6.4l9,5.4l9-5.4L10,1L1,6.4z" class="st0"></path>
          </svg>
      </span>`;

function sampleAddToCart(e) {
  const curtBtn = e.currentTarget;
  setTimeout(() => {
    curtBtn.setAttribute("disabled", true);
    curtBtn.innerHTML = `${sampleHtmlSvg} Sample already added`;
    const tabButtons = document.querySelectorAll(".custom_drawer-view button");
    const tabContents = document.querySelectorAll('.custom_tab-content');
    if (tabContents.length > 0) {
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));
        tabButtons[tabButtons.length - 1].classList.add('active');
        tabContents[tabContents.length - 1].classList.add('active');
    }
  }, 4000);
}

function variantLabel() {
 setTimeout(() => {
    const varDiv = document.querySelectorAll(".option-selector .option-selector__btns input");
     varDiv.forEach(input => {
        input.addEventListener('change', () => {
          setTimeout(() => {
            location.reload();
          }, 800)
        });
    });
 }, 2000)
}

variantLabel();